import { Box, Button, Icon, Section, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const Content = () => {
  const { navigation } = useNavigation()

  return (
    <Box
      background="viridian100"
      borderRadius={{
        all: 'abs016',
      }}
      padding="s24"
      gap="s16"
    >
      <Box flexDirection="row" gap="s12">
        <Box
          height="s32"
          width="s32"
          justifyContent="center"
          alignItems="center"
          background="viridian1000"
          padding="s4"
          borderRadius={{
            all: 'abs012',
          }}
        >
          <Icon.Medium icon="lightbulb" color="grey000White" />
        </Box>
        <Text.Normal>
          {i18n.t('app_store_v2.apps.payroll_bundle.settings.employees_data.card_description')}
        </Text.Normal>
      </Box>

      <Button.Router to={navigation.employees.fullPath()} type="secondary">
        {i18n.t('app_store_v2.apps.payroll_bundle.settings.employees_data.button')}
      </Button.Router>
    </Box>
  )
}

const EmployeesData = () => {
  return (
    <Section
      title={i18n.t('app_store_v2.apps.payroll_bundle.settings.employees_data.title')}
      illustration={'user-male-female'}
      description={i18n.t(
        'app_store_v2.apps.payroll_bundle.settings.employees_data.new_settings_description'
      )}
    >
      <Content />
    </Section>
  )
}

export default EmployeesData
